export const WORLD_CUP_RANKINGS_REQUEST = 'worldCupRankingsRequest';
export const WORLD_CUP_RANKINGS_FAILURE = 'worldCupRankingsFailure';
export const WORLD_CUP_RANKINGS_SUCCESS = 'worldCupRankingsSuccess';
